import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  card: {
    '&&': {
      padding: 0,
      border: `1px solid ${theme.colors.card_divider}`,
      marginBottom: theme.spacing(3),
      background: theme.colorPalette.white
    }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    padding: theme.spacing(4),
    borderBottom: `1px solid ${theme.colors.card_divider}`
  },
  heading: { '&&': { margin: 0, fontSize: 16, fontWeight: 600 } },
  list: { listStyle: 'none', padding: 0, margin: 0 },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    padding: theme.spacing(3, 4),
    '& + &': { borderTop: `1px solid ${theme.colors.card_divider}` }
  },
  status: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 22,
    height: 22,
    borderRadius: '50%',
    border: `1px solid ${theme.colors.card_divider}`
  },
  complete: {
    background: theme.colorPalette.green_75,
    borderColor: theme.colorPalette.green_75,
    color: theme.colorPalette.white
  },
  label: { '&&': { fontWeight: 600, fontSize: 14 } },
  hint: { color: theme.colors.text_secondary }
}));
